define(function (require) {
	// general
	const CN = require('civicsUtils/constants');
	// views

	return Marionette.CollectionView.extend({
		initialize: function (options) {
			this.config = options.config;
			this.childView = options.childView;
			this.disableMapClick = options.disableMapClick;
		},
		childViewOptions: function (model, index) {
			return {
				config: this.config,
				disableMapClick: this.disableMapClick
			};
		},
		onRender: function () {
			if (__DEV__) console.log('cpv_logs onRender');
		},
	});
});
